<div class="card mt-4">
    <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbDossier"></p-breadcrumb>
</div>
<div class="card mt-4">


    <div class="font-semibold text-xl mb-4">Liste des dossiers - {{this.nomDo}} - {{this.DO}}</div>
    <p-toolbar styleClass="mb-6">
        <ng-template #start>
            <!-- <p-button label="Ajouter" icon="pi pi-plus" severity="primary" class="mr-2"  /> -->
            <p-button severity="secondary" label="Supprimer" icon="pi pi-trash" outlined
                [style]="{'color': 'var(--primary-color)'}"
                [disabled]="!selectedDossiers || !selectedDossiers.length " (onClick)="deleteSelectedDossiers()"/>
            <!-- <p-button severity="secondary" label="Activer" icon="pi pi-check" outlined
                [style]="{'color': 'var(--primary-color)'}" [disabled]="!selectedDossiers || !selectedDossiers.length "
                 /> -->

        </ng-template>

        <ng-template #end>
            <!-- <p-button label="Importer en masse" icon="pi pi-upload" styleClass="p-button-primary" class="mr-2"
                /> -->

            <p-button (click)="ExporterDossiersCSV()" label="Exporter en CSV" icon="pi pi-download" severity="secondary"
                [disabled]="loading || !dossiers || dossiers.length === 0" ></p-button>
        </ng-template>
    </p-toolbar>
    <p-table #dt1 [value]="dossiers" dataKey="code_interne" [rows]="10" [rowHover]="true" [showGridlines]="true"
        [paginator]="true" [tableStyle]="{ 'min-width': '75rem' }" [(selection)]="selectedDossiers"
        currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} dossiers"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="rowsPerPageOptions" exportFilename="dossiers_export"
        [loading]="loading" [globalFilterFields]="[
            'Societe_Nom',
            'Contact_Nom',
            'NoDossierClient',
  'DateCreation',
  'AgentCreation',
  'Destinataire',
  'Objet_Libelle'

]" responsiveLayout="scroll">
        <ng-template #caption>
            <div class="flex justify-between items-center flex-column sm:flex-row">
                <button pButton label="Réintialiser" class="p-button-outlined mb-2" icon="pi pi-filter-slash"
                    (click)="clear(dt1)"></button>
                <p-iconfield iconPosition="left" class="ml-auto">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                    <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)" placeholder="Rechercher" />
                </p-iconfield>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 2rem; font-weight: bold !important; text-align: center; vertical-align: middle;">
                    <p-tableHeaderCheckbox />
                </th>
                <th
                    style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center; white-space: nowrap;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Code Dossier</span>
                        <p-columnFilter type="text" field="code_interne" display="menu"
                            placeholder="Rechercher par Code Dossier" />
                    </div>
                </th>
                <th
                    style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center; white-space: nowrap;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Societé & Contact</span>
                        <p-columnFilter type="text" field="Societe_Nom" display="menu"
                            placeholder="Rechercher par Societé & Contact" />
                    </div>
                </th>



                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;"> Date de création</span>
                        <p-columnFilter type="text" field="DateCreation" display="menu"
                            placeholder="Rechercher par Date de création " />
                    </div>
                </th>

                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Agent </span>
                        <p-columnFilter type="text" field="AgentCreation" display="menu" placeholder="Rechercher par Agent" />
                    </div>
                </th>

                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;"> Destinataire</span>
                        <p-columnFilter type="text" field="Destinataire" display="menu"
                            placeholder="Rechercher par Destinataire" />
                    </div>
                </th>
                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;"> Objet</span>
                        <p-columnFilter type="text" field="Objet_Libelle" display="menu" placeholder="Rechercher par Objet" />
                    </div>
                </th>
                <th style="width: 6rem; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-center items-center">
                        <span style="font-weight: bold;">Actions</span>
                    </div>
                </th>
            </tr>

        </ng-template>

        <ng-template #body let-dossier>
            <tr>
                <td style="text-align: center; vertical-align: middle;">
                    <p-tableCheckbox [value]="dossier" />
                </td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ dossier.code_interne }}</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ dossier.Societe_Nom }} - {{ dossier.Contact_Nom }}
                </td>

                <td style="padding: 0.5rem; white-space: nowrap;">{{ dossier.DateCreation | date:'dd/MM/yyyy HH:mm' }}
                </td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ dossier.AgentCreation }}</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ dossier.Destinataire }}</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ dossier.Objet_Libelle }}</td>



                <td class="text-center" style="padding: 0.5rem; vertical-align: middle;">
                    <div class="flex justify-center items-center gap-2">

                        <p-button icon="pi pi-eye" class="mr-1" [rounded]="true" [outlined]="true" (click)="openDetailsDossier(dossier)"/>
                        <!-- <p-button icon="pi pi-pencil" [rounded]="true" [outlined]="true"></p-button> -->
                        <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true" (click)="deleteByOne(dossier)"></p-button>
                    </div>
                </td>
            </tr>

        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="8">Aucun dossier trouvé.</td>
            </tr>
        </ng-template>
        <ng-template #loadingbody>
            <tr>
                <td colspan="8">Chargement des données dossiers. Veuillez patienter.</td>
            </tr>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="DetailsDialog" [style]="{ width: '100%', maxWidth: '1000px' }" header="Détails du dossier"
        [modal]="true">
        <ng-template #content>
            <div class="flex flex-col gap-6">

                <!-- Ligne 1 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code Interne</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.code_interne" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Code DO</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.code_DO" class="w-full" [readOnly]="true" />
                    </div>
                </div>

                <!-- Ligne 2 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Société</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Societe_Nom" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Identifiant du Société</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Societe_Identifiant" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Ligne 3 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Nom Contact</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Contact_Nom" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Destinataire</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Destinataire" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Ligne 4 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Objet</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Objet_Libelle" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Catégorie</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Categorie_Libelle" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Ligne 5 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Statut</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Statut_Libelle" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Priorité</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Priorite_Libelle" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Ligne 6 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Canal</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Media_Libelle" class="w-full"
                            [readOnly]="true" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Référence</label>
                        <input type="text" pInputText [(ngModel)]="selectedDossierItem.Reference" class="w-full"
                            [readOnly]="true" />
                    </div>
                </div>

                <!-- Dates -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Date Création</label>
                        <input type="text" pInputText [value]="selectedDossierItem.DateCreation | date:'short'" class="w-full"
                            readonly />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Date Fermeture</label>
                        <input type="text" pInputText [value]="selectedDossierItem.DateFermeture | date:'short'" class="w-full"
                            readonly />
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <label class="block font-bold mb-2">Email Destinataire</label>
                    <input type="email" pInputText [(ngModel)]="selectedDossierItem.Destinataire_AdrEmail" class="w-full"
                        [readOnly]="true" />
                </div>

                <!-- Description -->
                <div>
                    <label class="block font-bold mb-2">Description</label>
                    <textarea pTextarea [(ngModel)]="selectedDossierItem.Description" rows="3" class="w-full"
                        [readOnly]="true"></textarea>
                </div>

            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Fermer" icon="pi pi-times" text (click)="hideDialog()" />
        </ng-template>
    </p-dialog>


    <p-confirmdialog [style]="{ width: '450px' }" />

</div>

<p-toast />
